import { useQueryClient } from '@tanstack/react-query';
import { type LabelInValue, type VideoContentObject, createVideoContentObject } from 'models';
import { useMutation } from 'query';
import type { FileUploadDone } from 'ui';
import { createVideo } from '../../services';
import { getVideosQueryKey } from '../keys';

type VideoData = {
  coverPhoto?: FileUploadDone;
  featuredInChannels: boolean;
  htmlContent: string;
  name: string;
  organizationId: string;
  recordedAt: Date;
  showInChannels: boolean;
  tags?: LabelInValue[];
  textContent: string;
};

export const useCreateVideoMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<VideoContentObject, VideoData>({
    async mutationFn({
      coverPhoto,
      featuredInChannels,
      htmlContent,
      name,
      organizationId,
      recordedAt,
      showInChannels,
      tags,
      textContent,
    }) {
      const { data } = await createVideo({
        video: {
          contentable_id: organizationId,
          contentable_type: 'Organization',
          cover_photo: coverPhoto?.response,
          featured_in_channels: featuredInChannels,
          html_content: htmlContent,
          name,
          // TODO: hardcode for now because we do not have price in application model
          price_option: 'free',
          recorded_at: recordedAt.toISOString(),
          show_in_channels: showInChannels,
          tag_ids: tags?.map((tag) => tag.value),
          text_content: textContent,
        },
      });

      return createVideoContentObject(data);
    },
    async onSuccess(_) {
      await queryClient.invalidateQueries({ queryKey: getVideosQueryKey({}) });
    },
  });
};
